import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center px-6" data-testid="admin-login">
      <motion.div initial={{opacity:0, y:20}} animate={{opacity:1, y:0}} transition={{duration:1}} className="w-full max-w-md">
        <Link to="/" className="block mb-12 text-center">
          <div className="font-cinzel text-[10px] tracking-[0.4em] text-[#C8A45D]">NEXUS LEGAL</div>
          <div className="font-serif-display text-2xl text-white/90 mt-2">Chamber Console</div>
        </Link>
        <div className="hairline w-16 mx-auto mb-12"/>
        <form onSubmit={submit} className="space-y-6">
          <input type="email" required className="nx-input" placeholder="Admin Email" value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email"/>
          <input type="password" required className="nx-input" placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="login-password"/>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="mt-10 text-center text-[10px] font-cinzel tracking-[0.3em] text-white/30">RESTRICTED ACCESS · CHAMBER STAFF</p>
      </motion.div>
    </div>
  );
}
